export const common = {
  next: "Siguiente",
  previous: "Anterior",
  page: "Página",
  cancel: "Cancelar",
  save: "Guardar",
  scrollToBottom: "Desplazarse hacia abajo",
  footer: {
    copyright: "© {{year}} Araria por WeBizz. Todos los derechos reservados.",
    about:
      "Araria es una plataforma para conversaciones e interacciones con IA. Permite al usuario conversar con modelos de IA, subir imágenes y usar una variedad de funciones de IA. Araria es un producto brasileño desarrollado por WeBizz.",
    menu: "Menú",
    home: "Inicio",
    blog: "Blog",
    pricing: "Precios",
    featureRequest: "Solicitar Funcionalidad",
    resources: "Recursos",
    support: "Soporte",
    privacy: "Política de Privacidad",
    terms: "Términos de Servicio",
    accountDeletion: "Eliminación de Cuenta",
    documentation: "Documentación",
    api: "API",
    contact: "Contacto",
    github: "GitHub",
  },
  notFound: {
    title: "404",
    heading: "Página no Encontrada",
    description: "La página que estás buscando no existe o fue movida.",
    button: "Volver al Inicio",
  },
  folders: {
    create: "Crear",
    new: "Nueva Carpeta",
    namePlaceholder: "Ingresá el nombre de la carpeta...",
    rename: "Renombrar carpeta",
    delete: "Eliminar carpeta",
    moveTo: "Mover a {{name}}",
    removeFromFolder: "Quitar de la carpeta",
  },
  contact: {
    title: "Contacto",
    subtitle: "Ponete en contacto con nosotros",
    form: {
      name: "Nombre",
      email: "Email",
      company: "Empresa",
      message: "Mensaje",
      submit: "Enviar",
      success: "Mensaje enviado correctamente",
      error: "Error al enviar el mensaje",
    },
  },
  user: {
    menu: {
      title: "Menú de Usuario",
      profile: "Perfil",
      payments: "Pagos",
      usage: "Uso",
      affiliate: "Programa de Afiliados",
      logout: "Cerrar Sesión",
      settings: "Configuraciones",
      support: "Atención al Cliente", // More specific than just "Soporte"
      features: "Solicitar Funcionalidad",
    },
  },
  soon: {
    title: "Próximamente",
    heading: "¡Nuestro equipo está trabajando en esto!",
    description: "Seguí las novedades en nuestro blog y redes sociales.",
    button: "Volver al Inicio",
    blog: "Blog",
  },
};
